// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"1bbc1a74","453":"30db9d22"}[chunkId] + ".chunk.js";
};